import HubspotSetupPanel from './HubspotSetupPanel';

export default HubspotSetupPanel;
